import { render, staticRenderFns } from "./LicenseDetail.vue?vue&type=template&id=29c1a0f0"
import script from "./LicenseDetail.vue?vue&type=script&lang=js"
export * from "./LicenseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports